// Generated by @-/dev.improve.haniverse.assets.graphemes.images.
// Do not edit by hand.

import type { GraphemeMeaningImageEntry } from "#types";

export const graphemeMeaningImageList: readonly GraphemeMeaningImageEntry[] = [
  {
    "character": "㇀",
    "urlPath": "/graphemes/meaning/images/u31c0.png"
  },
  {
    "character": "㇈",
    "urlPath": "/graphemes/meaning/images/u31c8.png"
  },
  {
    "character": "㇏",
    "urlPath": "/graphemes/meaning/images/u31cf.png"
  },
  {
    "character": "㇒",
    "urlPath": "/graphemes/meaning/images/u31d2.png"
  },
  {
    "character": "一",
    "urlPath": "/graphemes/meaning/images/u4e00.png"
  },
  {
    "character": "七",
    "urlPath": "/graphemes/meaning/images/u4e03.png"
  },
  {
    "character": "万",
    "urlPath": "/graphemes/meaning/images/u4e07.png"
  },
  {
    "character": "三",
    "urlPath": "/graphemes/meaning/images/u4e09.png"
  },
  {
    "character": "上",
    "urlPath": "/graphemes/meaning/images/u4e0a.png"
  },
  {
    "character": "下",
    "urlPath": "/graphemes/meaning/images/u4e0b.png"
  },
  {
    "character": "不",
    "urlPath": "/graphemes/meaning/images/u4e0d.png"
  },
  {
    "character": "丨",
    "urlPath": "/graphemes/meaning/images/u4e28.png"
  },
  {
    "character": "丰",
    "urlPath": "/graphemes/meaning/images/u4e30.png"
  },
  {
    "character": "丶",
    "urlPath": "/graphemes/meaning/images/u4e36.png"
  },
  {
    "character": "丷",
    "urlPath": "/graphemes/meaning/images/u4e37.png"
  },
  {
    "character": "丸",
    "urlPath": "/graphemes/meaning/images/u4e38.png"
  },
  {
    "character": "主",
    "urlPath": "/graphemes/meaning/images/u4e3b.png"
  },
  {
    "character": "丿",
    "urlPath": "/graphemes/meaning/images/u4e3f.png"
  },
  {
    "character": "乚",
    "urlPath": "/graphemes/meaning/images/u4e5a.png"
  },
  {
    "character": "二",
    "urlPath": "/graphemes/meaning/images/u4e8c.png"
  },
  {
    "character": "从",
    "urlPath": "/graphemes/meaning/images/u4ece.png"
  },
  {
    "character": "儿",
    "urlPath": "/graphemes/meaning/images/u513f.png"
  },
  {
    "character": "兀",
    "urlPath": "/graphemes/meaning/images/u5140.png"
  },
  {
    "character": "光",
    "urlPath": "/graphemes/meaning/images/u5149.png"
  },
  {
    "character": "凡",
    "urlPath": "/graphemes/meaning/images/u51e1.png"
  },
  {
    "character": "十",
    "urlPath": "/graphemes/meaning/images/u5341.png"
  },
  {
    "character": "卜",
    "urlPath": "/graphemes/meaning/images/u535c.png"
  },
  {
    "character": "⺊",
    "urlPath": "/graphemes/meaning/images/u2e8a.png"
  },
  {
    "character": "卡",
    "urlPath": "/graphemes/meaning/images/u5361.png"
  },
  {
    "character": "土",
    "urlPath": "/graphemes/meaning/images/u571f.png"
  },
  {
    "character": "坐",
    "urlPath": "/graphemes/meaning/images/u5750.png"
  },
  {
    "character": "士",
    "urlPath": "/graphemes/meaning/images/u58eb.png"
  },
  {
    "character": "大",
    "urlPath": "/graphemes/meaning/images/u5927.png"
  },
  {
    "character": "天",
    "urlPath": "/graphemes/meaning/images/u5929.png"
  },
  {
    "character": "太",
    "urlPath": "/graphemes/meaning/images/u592a.png"
  },
  {
    "character": "夫",
    "urlPath": "/graphemes/meaning/images/u592b.png"
  },
  {
    "character": "失",
    "urlPath": "/graphemes/meaning/images/u5931.png"
  },
  {
    "character": "川",
    "urlPath": "/graphemes/meaning/images/u5ddd.png"
  },
  {
    "character": "干",
    "urlPath": "/graphemes/meaning/images/u5e72.png"
  },
  {
    "character": "木",
    "urlPath": "/graphemes/meaning/images/u6728.png"
  },
  {
    "character": "止",
    "urlPath": "/graphemes/meaning/images/u6b62.png"
  },
  {
    "character": "正",
    "urlPath": "/graphemes/meaning/images/u6b63.png"
  },
  {
    "character": "玉",
    "urlPath": "/graphemes/meaning/images/u7389.png"
  },
  {
    "character": "王",
    "urlPath": "/graphemes/meaning/images/u738b.png"
  },
  {
    "character": "玨",
    "urlPath": "/graphemes/meaning/images/u73a8.png"
  },
  {
    "character": "讠",
    "urlPath": "/graphemes/meaning/images/u8ba0.png"
  },
  {
    "character": "许",
    "urlPath": "/graphemes/meaning/images/u8bb8.png"
  },
  {
    "character": "讻",
    "urlPath": "/graphemes/meaning/images/u8bbb.png"
  },
  {
    "character": "非",
    "urlPath": "/graphemes/meaning/images/u975e.png"
  }
];
